import {HttpBackend, HttpClient, HttpResponse } from '@angular/common/http';
import {Inject, Injectable } from '@angular/core';
import { APP_CONFIG, AppConfig } from '@src/app.config';
import { RequestService } from '@src/app/shared/services/http/request/request.service';
import {Observable, of} from "rxjs";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AuthApiService {
  private httpNoIntercept: HttpClient;

  constructor(
    @Inject(APP_CONFIG) private appConfig: AppConfig,
    private requestService: RequestService,
    private httpBackend: HttpBackend,
  ) {
    this.httpNoIntercept = new HttpClient(this.httpBackend);
  }

  /**
   * This version bypasses your interceptors entirely.
   */
  checkAuth(token: string): Observable<{ active: boolean }> {
    const url = `${this.appConfig.baseApiEndpoint}/app/auth/introspect`;

    // if you need to pass the token in headers instead of via interceptor:
    const headers = { Authorization: `Bearer ${token}` };

    return this.httpNoIntercept
      .get<any>(url, { headers, observe: 'response' })
      .pipe(map(resp => resp.body as { active: boolean }));
  }

  sendOtp(phoneNumber: string): Observable<{ token: string }> {
    const url = `${this.appConfig.baseApiEndpoint}/app/auth/requestPhoneCode`
    return this.requestService.post(url, {phoneNumber}).pipe(map(r => r.body))
  }

  verifyOtp(token: string, code: string): Observable<{ accessToken: string }> {
    const url = `${this.appConfig.baseApiEndpoint}/app/auth/confirmPhoneCode`
    return this.requestService.post(url, {token, code}).pipe(map(r => r.body))
  }

  loginOtp(token: string): Observable<{ accessToken: string, expires: number }> {
    const url = `${this.appConfig.baseApiEndpoint}/app/auth/otpLogin`
    return this.requestService.post(url, {token}).pipe(map(r => r.body))
  }
}
